export default __webpack_public_path__ + "static/media/folder-active.3a6b3b79.svg";